module.exports = __webpack_public_path__ + "static/media/btn_parrot.ffb98368.png";